import { render } from "./OpenLayout.vue?vue&type=template&id=62837353&ts=true"
import script from "./OpenLayout.vue?vue&type=script&lang=ts"
export * from "./OpenLayout.vue?vue&type=script&lang=ts"

import "./OpenLayout.vue?vue&type=style&index=0&id=62837353&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__